/** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import { css } from "@emotion/css";

import { format, formatISO } from "date-fns";
import React, { memo } from "react";
import { Column } from "./Calendar";
import { NoteList } from "../view/NoteList";
import {
  isInMonthBacklog,
  isInWeekBacklog,
  putInWeekBacklog,
  putInMonthBacklog,
} from "../state/data/utils";
import { DayBodyColumn } from "../calendar/DayBodyColumn";

export const CalendarBodyColumn = memo(({ col }: { col: Column }) => {
  switch (col.type) {
    case "DAY":
      return <DayBodyColumn col={col} />;
    case "WEEK":
      return (
        <div tw="h-full relative">
          <div tw="sticky top-0">
            <div
              style={{
                height: "calc(100vh - 150px)",
                position: "relative",
              }}
            >
              <div tw="overflow-y-auto overflow-x-hidden h-full">
                <NoteList
                  id={col.type + formatISO(col.d)}
                  selector={isInWeekBacklog(col.d)}
                  effector={putInWeekBacklog(col.d)}
                />
              </div>
            </div>
          </div>
        </div>
      );
    case "MONTH":
      return (
        <div tw="h-full relative">
          <div tw="sticky top-0">
            <div
              style={{
                height: "calc(100vh - 150px)",
                position: "relative",
              }}
            >
              <div tw="overflow-y-auto overflow-x-hidden h-full">
                <NoteList
                  id={col.type + formatISO(col.d)}
                  selector={isInMonthBacklog(col.d)}
                  effector={putInMonthBacklog(col.d)}
                />
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return <h1>Blank</h1>;
  }
});
